import React from 'react'

const DEFAULT_EVENTS = ['click', 'keyup', 'touchstart', 'touchmove']

interface UseDetectInteractionArgs {
  disable?: boolean
  events?: string[]
  onInteraction: () => void
}

const useDetectInteraction = ({
  disable,
  events = DEFAULT_EVENTS,
  onInteraction,
}: UseDetectInteractionArgs) => {
  const handleInteraction = React.useCallback(() => {
    if (disable) {
      return
    }
    onInteraction()
  }, [onInteraction, disable])

  React.useEffect(() => {
    if (!disable) {
      events.forEach((event: string) =>
        window.addEventListener(event, handleInteraction, true)
      )
    }

    return () => {
      events.forEach((event: string) =>
        window.removeEventListener(event, handleInteraction, true)
      )
    }
  }, [handleInteraction, disable, events])
}

export default useDetectInteraction
